import { castDate } from "@caredna-marlin/utils/dates";
import { CommandIndexCombinedDataQuery } from "~/graphql/__generated__/graphql";

import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { LocalVisitRequest } from "~/utils/eventsHelper";
import { useSelectableServiceLineIds } from "./useDefaultServiceLines";

const useVisitRequests = (visitRequestTasks:  CommandIndexCombinedDataQuery["task"], date: Date) => {
  const orgConfig = useOrgConfig();
  const allowedServiceLineIds = useSelectableServiceLineIds();

  const localVisitRequests: LocalVisitRequest[] = [];

  visitRequestTasks.forEach((task, index) => {
    const details = JSON.parse(`${task.details ?? "{}"}`);
    const {
      duration,
      serviceIds,
      constraints,
      visitTypeId,
      serviceLineId
    } = details;

    const visitType = orgConfig.visitTypes[visitTypeId];
    const serviceLine = orgConfig.serviceLines[serviceLineId];

    if (!visitType || !serviceLine) { return; }
    if (!allowedServiceLineIds.includes(serviceLineId)) { return; }

    const currentDateTime = constraints?.preferredTime
      ? castDate(constraints.preferredTime)
      : new Date();

    const sameDay =
      currentDateTime.getFullYear() === date.getFullYear() &&
      currentDateTime.getMonth() === date.getMonth() &&
      currentDateTime.getDate() === date.getDate();

    if (!sameDay) return;

    const id = -(index + 1);

    localVisitRequests.push({
      id,
      taskId: task.id,
      date: currentDateTime,
      visitType,
      serviceLine,
      duration,
      serviceIds,
      patient: task.patient,
    });
  });

  return localVisitRequests;
};

export default useVisitRequests;
